<template>
  <v-container id="cuentaBancaria-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-briefcase-account-outline" inline class="px-5 py-3" title="Cuentas Bancarias">
      <template v-slot:after-title>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#ac8a2e" dark icon v-bind="attrs" v-on="on">
              <v-icon large color="#ac8a2e">
                mdi-briefcase-plus-outline
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <validation-observer v-slot="{ handleSubmit }">
                  <form id="altaclub" @submit.prevent="handleSubmit(validateForm)">
                    <v-row align="center" justify="center">
                      <v-col cols="12" md="6">
                        <validation-provider v-slot="{ errors }" name="numero" rules="max:20|required">
                          <v-text-field v-model="dataForm.numero" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Número" />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="6">
                        <validation-provider v-slot="{ errors }" name="banco" rules="required">
                          <v-select v-model="dataForm.banco_id" color="#ac8a2e" :error-messages="errors" label="Banco" item-value="id" item-text="descripcion" :items="bancos">
                            <template v-slot:item="{ attrs, item, on }">
                              <v-list-item v-bind="attrs" active-class="secondary elevation-4 white--text" class="v-sheet" elevation="0" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.descripcion" />
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </validation-provider>
                      </v-col>
                      <v-col cols="12">
                        <validation-provider v-slot="{ errors }" name="descripción" rules="max:45|required">
                          <v-textarea
                            v-model="dataForm.descripcion"
                            color="#ac8a2e"
                            :error-messages="errors"
                            name="input-6-1"
                            label="Descripción"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="dataForm.propia_sn"
                          class="pa-0 ml-0"
                        >
                          <span
                            slot="label"
                            class="black--text"
                          >
                            Cuenta propia
                          </span>
                        </v-checkbox>
                      </v-col>
                    </v-row>
                  </form>
                </validation-observer>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>
                  <v-btn color="blue darken-1" text form="altaclub" type="submit">
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="search" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="cuentas"
        :search.sync="search"
        multi-sort
      >
        <template v-slot:[`item.propia_sn`]="{ item }">
          <v-icon
            v-if="item.propia_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-if="$can('M_parametros')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        dialog: false,
        search: undefined,
        headers: [
          { text: 'Número', sortable: false, value: 'numero' },
          { text: 'Banco', value: 'banco.descripcion' },
          { text: 'Propia', value: 'propia_sn' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        editedIndex: -1,
        cuentas: [],
        bancos: [],
        dataForm: {
          id: '',
          descripcion: '',
          propia_sn: false,
          numero: '',
          banco_id: '',
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Cuenta Bancaria' : 'Editar Cuenta Bancaria'
      },
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.getCuentas()
      this.getBancos()
    },
    methods: {

      getCuentas: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/cuenta_bancaria_get' }).then(response => {
          this.cuentas = response
        })
      },

      getBancos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/banco_get' }).then(response => {
          this.bancos = response
        })
      },

      editItem (item) {
        this.editedIndex = this.cuentas.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.dataForm.propia_sn = false
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/cuenta_bancaria_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Cuenta eliminada exitosamente'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getCuentas()
      },

      validateForm (scope) {
        this.enviarCuenta()
      },

      enviarCuenta: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/cuenta_bancaria_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.getCuentas()
          this.close()
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de Cuenta exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
